import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AngularMyDatePickerDirective, IAngularMyDpOptions, IMyDateModel } from "angular-mydatepicker";
import { Timezone } from "src/app/enums/timezone";

@Component({
  selector: "app-calendar",
  templateUrl: "./calendar.component.html",
  styleUrls: ["./calendar.component.scss"],
})
export class CalendarComponent {
  @Input() value?: string | null = null;
  @Input() timezone?: Timezone = Timezone.Eastern;
  @Input() placeholder = "";
  @Input() class = "";

  @Output() dateChanged = new EventEmitter<string>();

  @ViewChild("datepicker") datepicker: AngularMyDatePickerDirective;

  readonly DATEPICKER_OPTIONS: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: "dd.mm.yyyy",
    firstDayOfWeek: "su",
    dayLabels: {
      su: "S",
      mo: "M",
      tu: "T",
      we: "W",
      th: "T",
      fr: "F",
      sa: "S",
    },
    monthLabels: {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "Jully",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    },
    selectorHeight: "220px",
    selectorWidth: "200px",
    showSelectorArrow: false,
    stylesData: {
      styles: `
          .myDpIconLeftArrow,
          .myDpIconRightArrow {
              color: red;
          }
          .myDpSelector{
            border:none;
            box-shadow: none;
            background-color:#fff;
          }
          .myDpMonthYearText .myDpYearLabel{
             display:none;
          }
          .myDpMonthYearText .myDpMonthLabel{
            color: #000;
            font-weight: 700;
            font-size: 16px;
          }
          .myDpSelector .myDpCalTable{
             border-collapse:separate;
          }
          .myDpSelector .myDpTableSingleDay{
            font-weight: 600;
          }
          .myDpSelector .myDpHighlight{
            color:#CE1A24;
          }
          .myDpSelector .myDpDaycell{
            height:26px;
          }
          .myDpSelector .myDpSelectedDay{
              border: 1px solid #0778E4;
              border-radius:100%;
          }
          .myDpSelector .myDpWeekDayTitle{
              font-weight:700;
          }
          .myDpIconLeftArrow{
            position:relative;
          }
          .myDpIconLeftArrow::before{
            content:' ';
            position:absolute;
            top:50%;
            transform:translateY(-50%);
            left:0;
            width:12px;
            height:12px;
            background-repeat:no-repeat;
            background-position:center center;
            background-size:cover;
            background-image:url('assets/img/icons/arrowLeft.svg');
          }
          .myDpIconRightArrow{
            position:relative;
          }
          .myDpIconRightArrow::before{
            content:' ';
            position:absolute;
            top:50%;
            transform:translateY(-50%);
            right:0;
            width:12px;
            height:12px;
            background-repeat:no-repeat;
            background-position:center center;
            background-size:cover;
            background-image:url('assets/img/icons/arrowRight.svg');
          }
      `,
    },
  };

  isDatepickerOpen = false;

  toggleDatepicker() {
    this.isDatepickerOpen = !this.isDatepickerOpen;
    this.datepicker.toggleCalendar();
  }

  closeDatepicker() {
    this.isDatepickerOpen = false;
    this.datepicker.closeCalendar();
  }

  onDateChanged(event: IMyDateModel): void {
    this.isDatepickerOpen = false;

    const date = event?.singleDate?.formatted ?? null;

    if (date !== null) {
      const { day, month, year } = event.singleDate.date;

      const offset = this.getTimezoneOffset(this.timezone);

      const date = new Date(0);
      date.setFullYear(year);
      date.setMonth(month);
      date.setDate(day);
      date.setHours(offset);

      // const formattedDate = `${year}-${("0" + month).slice(-2)}-${("0" + day).slice(-2)}T${(
      //   "0" + Math.abs(offset)
      // ).slice(-2)}:00:00.000Z`;

      this.dateChanged.emit(date.toISOString());
    }
  }

  private getTimezoneOffset(timezone: Timezone) {
    switch (timezone) {
      case Timezone.Eastern:
        return 5;
      case Timezone.Central:
        return 6;
      case Timezone.Mountain:
        return 7;
      case Timezone.Pacific:
        return 8;
      case Timezone.Alaskan:
        return 9;
      case Timezone.Hawaiian:
        return 10;
      default:
        return 0;
    }
  }
}
